import { useCallback } from 'react';

import { useSelectorShallow } from './useSelectorShallow';
import { TRootState, TCustomSelector, TEqualityFunction } from '../types';

export const useCustomSelectorShallow = <
    TSelected,
    TReducerName extends keyof TRootState
>(
    reducerName: TReducerName,
    selector: TCustomSelector<TSelected, TReducerName> = (state) => state,
    equalityFn?: TEqualityFunction<TSelected>
) => {
    const selectorMemo = useCallback(
        (state: TRootState) =>
            selector(state[reducerName] || ({} as TRootState[TReducerName])),
        [reducerName, selector]
    );

    return useSelectorShallow(selectorMemo, equalityFn);
};
